module.exports = __webpack_public_path__ + "media/images/exp-six-f06350d72bd7dc9cc901273a09313b97.png";